import { render, staticRenderFns } from "./BeneficiaryBadgeCreateEditModal.vue?vue&type=template&id=1cc7c5fe&scoped=true"
import script from "./BeneficiaryBadgeCreateEditModal.vue?vue&type=script&lang=js"
export * from "./BeneficiaryBadgeCreateEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc7c5fe",
  null
  
)

export default component.exports